import api from './axios';

export type AccountReceivableStatus = 'pendiente' | 'pagado' | 'vencido' | 'cancelado';

export interface AccountReceivable {
  id: number;
  orderId: number;
  paymentId: number | null;
  customerId: number;
  customer?: {
    id: number;
    name: string;
    document: string;
    phone?: string;
    email?: string;
  };
  order?: { id: number; code: string; total: number };
  amount: number;
  dueDate: string;
  status: AccountReceivableStatus;
  paidPaymentId: number | null;
  paidCashSessionId: number | null;
  paidAt: string | null;
  notes: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface AccountsReceivableSummary {
  totalPendiente: number;
  totalVencido: number;
  countPendientes: number;
  countVencidos: number;
  topDebtors: Array<{
    customer: { id: number; name: string; document: string };
    total: number;
    count: number;
  }>;
}

export const accountsReceivableApi = {
  getAll: (filters?: {
    status?: AccountReceivableStatus;
    customerId?: number;
    overdueOnly?: boolean;
  }) =>
    api.get<AccountReceivable[]>('/accounts-receivable', { params: filters }),
  getSummary: () => api.get<AccountsReceivableSummary>('/accounts-receivable/summary'),
  getById: (id: number) => api.get<AccountReceivable>(`/accounts-receivable/${id}`),
  pay: (id: number, payload: { method: string; reference?: string; currency?: 'PEN' | 'USD' }) =>
    api.post(`/accounts-receivable/${id}/pay`, payload),
  cancel: (id: number, notes?: string) =>
    api.post(`/accounts-receivable/${id}/cancel`, { notes }),
};
